<div class="personal-details-container">
  <app-spacer></app-spacer>

  <div class="text-container">
    <span class="title">Enter your personal details</span>
    <p class="subtitle">Please complete the form below to begin your application process.</p>
  </div>

  <app-spacer></app-spacer>

  <app-personal-details-form (formChange)="onPersonalInfoChange($event)">
  </app-personal-details-form>

  <app-spacer height="5px"></app-spacer>

  <app-identification-form
    (formChange)="onLookupFormChange($event)"
    (lookupTypeChange)="onLookupTypeChange($event)"
  >
  </app-identification-form>

  <app-spacer height="5px"></app-spacer>

  <app-contact-details-form (formChange)="onContactDetailsChange($event)">
  </app-contact-details-form>

  <app-spacer></app-spacer>

  <div class="w-full button-container">
    <app-cancel-button class="outline-button"></app-cancel-button>
    <app-primary-button
      class="primary-button"
      [disabled]="!isFormValid() || store.requestingRegistration()"
      (click)="initRegisteration()"
      [isLoading]="store.requestingRegistration()"
    >
    </app-primary-button>
  </div>
</div>
